// Mock data for race participants
// Updated with real data from 2026 IF Convention Sign Up form responses

export const mockParticipants = [
  {
    id: "1",
    lastUpdatedDate: "2025-11-02T13:59:29Z",
    fullName: "Ricomar Llamzon",
    loftName: "Monsters of the midway loft",
    emailAddress: "Ricomar_llamzon@icloud.com",
    mobile: "312-320-5343",
    role: ["breeder"],
    preferredNotificationMethod: ["email","text"],
    passcode: "RICA2026",
    breederInfo: {
      handlerName: null,
      assignedBirds: [],
      totalBirdsForRace: 5
    }
  },
  {
    id: "2",
    lastUpdatedDate: "2025-11-02T14:01:04Z",
    fullName: "Jose L Rosario",
    loftName: "RoseGold Loft",
    emailAddress: "jose954954@hotmail.com",
    mobile: "973-900-0213",
    role: ["breeder"],
    preferredNotificationMethod: ["email","text"],
    passcode: "JOSE2026",
    breederInfo: {
      handlerName: null,
      assignedBirds: [],
      totalBirdsForRace: 15
    }
  },
  {
    id: "3",
    lastUpdatedDate: "2025-11-02T14:03:58Z",
    fullName: "Chris Dairo",
    loftName: "CD Powerhouse Loft",
    emailAddress: "chris_dairo@yahoo.com",
    mobile: "908-416-0388",
    role: ["breeder"],
    passcode: "cdtest",
     hideContactInfo: true,
    preferredNotificationMethod: ["email","text","in-app"],
    handlerInfo: {
      section: "Central",
      totalBirds: 0,
      reserved: 0,
      openSlots: 5,
      breederApplicationMethod: ["in-app"],
      distanceFromRaceStation: null,
      breeders: []
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "4",
    lastUpdatedDate: "2025-11-02T15:37:38Z",
    fullName: "Tiago Rodrigues",
    loftName: "Tiago Loft",
    emailAddress: "tiagomrchitect@gmail.com",
    mobile: "908-227-2755",
    role: ["handler","breeder"],
    passcode: "cdtest2",
    preferredNotificationMethod: ["text"],
    handlerInfo: {
      section: "CENTRAL",
      totalBirds: null,
      reserved: 0,
      openSlots: null,
      breederApplicationMethod: null,
      distanceFromRaceStation: null,
      breeders: []
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "5",
    lastUpdatedDate: "2025-11-02T17:25:46Z",
    fullName: "Dennis Doyle",
    loftName: "Lynden Loft",
    emailAddress: "dennismdoyle@yahoo.com",
    mobile: "972-838-4173",
    role: ["breeder"],
    preferredNotificationMethod: ["email"],
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "6",
    lastUpdatedDate: "2025-11-04T16:51:04Z",
    fullName: "Dan Lionello",
    loftName: null,
    emailAddress: "dlionello@cox.net",
    mobile: "805-895-1012",
    role: ["breeder"],
    preferredNotificationMethod: ["text"],
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "7",
    lastUpdatedDate: "2025-11-04T19:53:50Z",
    fullName: "Angelo Mendez",
    loftName: "Toysoldiers",
    emailAddress: "Toysoldiers2718@gmail.com",
    mobile: "718-612-4208",
    role: ["breeder","handler"],
    preferredNotificationMethod: ["email","text"],
    handlerInfo: {
      section: "CENTRAL",
      totalBirds: null,
      reserved: 0,
      openSlots: null,
      breederApplicationMethod: null,
      distanceFromRaceStation: null,
      breeders: []
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "8",
    lastUpdatedDate: "2025-11-06T10:51:01Z",
    fullName: "Rishier Crisostomo",
    loftName: "Bulacan Loft",
    emailAddress: "rishier.crisostomo@outlook.com",
    mobile: "732-983-1651",
    role: ["breeder","handler"],
    preferredNotificationMethod: ["email","text","in-app"],
    passcode: "RISH2026",
    handlerInfo: {
      section: "NORTH",
      totalBirds: 40,
      reserved: 15, // Updated: 5 (Ricomar) + 5 (John) + 5 (Dan)
      openSlots: 22, // 40 - 15 - 3 breeders
      breederApplicationMethod: ["call"],
      distanceFromRaceStation: "260 miles",
      breeders: [
        {
          breederId: "1",
          breederName: "Ricomar Llamzon",
          loftName: "Monsters of the midway loft",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        },
        {
          breederId: "16",
          breederName: "John Cosgrove",
          loftName: "Purplemartin Loft",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        },
        {
          breederId: "17",
          breederName: "Dan Czarniak",
          loftName: "Dan Czarniak",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        }
      ]
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "9",
    lastUpdatedDate: "2025-11-06T11:11:04Z",
    fullName: "Baron Salcedo",
    loftName: "Baron Loft",
    emailAddress: "baron2loft@yahoo.com",
    mobile: "551-208-4430",
    role: ["breeder","handler"],
    preferredNotificationMethod: ["text"],
    passcode: "BARON2026",
    handlerInfo: {
      section: "CENTRAL",
      totalBirds: 70,
      reserved: 10, // Updated: 5 (Jose) + 5 (Dan)
      openSlots: 58, // 70 - 10 - 2 breeders
      breederApplicationMethod: ["call"],
      distanceFromRaceStation: "296 miles",
      breeders: [
        {
          breederId: "2",
          breederName: "Jose L Rosario",
          loftName: "RoseGold Loft",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        },
        {
          breederId: "17",
          breederName: "Dan Czarniak",
          loftName: "Dan Czarniak",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        }
      ]
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "10",
    lastUpdatedDate: "2025-11-06T12:48:05Z",
    fullName: "Wieslaw Mulawka",
    loftName: "Vinnie Loft",
    emailAddress: null,
    mobile: "973-444-0813",
    role: ["handler"],
    preferredNotificationMethod: ["text"],
    handlerInfo: {
      section: "NORTH",
      totalBirds: 15,
      reserved: 0,
      openSlots: 15,
      breederApplicationMethod: ["text"],
      distanceFromRaceStation: "306.483 miles",
      breeders: []
    }
  },
  {
    id: "11",
    lastUpdatedDate: "2025-11-06T13:42:51Z",
    fullName: "Charles Aiosa",
    loftName: "Father N Sons",
    emailAddress: "cjcs11@aol.com",
    mobile: "917-952-1284",
    role: ["breeder","handler"],
    preferredNotificationMethod: ["text"],
    handlerInfo: {
      section: "CENTRAL",
      totalBirds: 50,
      reserved: 4, // Updated: 4 (Jose)
      openSlots: 45, // 50 - 4 - 1 breeder
      breederApplicationMethod: ["text"],
      distanceFromRaceStation: "306 miles",
      breeders: [
        {
          breederId: "2",
          breederName: "Jose L Rosario",
          loftName: "RoseGold Loft",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        }
      ]
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "12",
    lastUpdatedDate: "2025-11-06T14:32:07Z",
    fullName: "Czeslaw Prelich",
    loftName: "Prelich Loft",
    emailAddress: "c.prelich@gmail.com",
    mobile: "973-704-5385",
    role: ["handler"],
    preferredNotificationMethod: ["email"],
    handlerInfo: {
      section: "NORTH",
      totalBirds: null,
      reserved: 0,
      openSlots: null,
      breederApplicationMethod: ["call"],
      distanceFromRaceStation: "303.313 miles",
      breeders: []
    }
  },
  {
    id: "13",
    lastUpdatedDate: "2025-11-06T16:25:03Z",
    fullName: "Philip Rabena",
    loftName: "Sheriff Loft",
    emailAddress: "sheriffsonloft@aol.com",
    mobile: "646-261-3082",
    role: ["breeder","handler"],
    preferredNotificationMethod: ["email","text"],
    handlerInfo: {
      section: "CENTRAL",
      totalBirds: null,
      reserved: 0,
      openSlots: null,
      breederApplicationMethod: ["text"],
      distanceFromRaceStation: null,
      breeders: []
    },
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "14",
    lastUpdatedDate: "2025-11-06T23:00:41Z",
    fullName: "Clark Berger",
    loftName: null,
    emailAddress: "cberger1980@yahoo.com",
    mobile: "484-809-2372",
    role: ["breeder"],
    preferredNotificationMethod: "email",
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "15",
    lastUpdatedDate: "2025-11-07T06:24:11Z",
    fullName: "Paul Keyser",
    loftName: "Keyser Loft",
    emailAddress: "pkeyser23@gmail.com",
    mobile: "856-470-6379",
    role: ["handler"],
    preferredNotificationMethod: ["email"],
    passcode: "PAUL2026",
    handlerInfo: {
      section: "SOUTH",
      totalBirds: 10,
      reserved: 2, // Updated: 2 (Dan)
      openSlots: 7, // 10 - 2 - 1 breeder
      breederApplicationMethod: ["email"],
      distanceFromRaceStation: "265 miles",
      breeders: [
        {
          breederId: "17",
          breederName: "Dan Czarniak",
          loftName: "Dan Czarniak",
          birds: [
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" },
            { bandNumber: "[To be added]", color: "[To be added]", sex: "[To be added]", status: "placeholder" }
          ]
        }
      ]
    }
  },
  {
    id: "16",
    lastUpdatedDate: "2025-11-07T09:34:53Z",
    fullName: "John Cosgrove",
    loftName: "Purplemartin Loft",
    emailAddress: "lonesomedove413@gmail.com",
    mobile: "609-532-7951",
    role: ["breeder"],
    preferredNotificationMethod: ["email"],
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
    id: "17",
    lastUpdatedDate: "2025-11-07T12:48:14Z",
    fullName: "Dan Czarniak",
    loftName: "Dan Czarniak",
    emailAddress: "dczarniak@yahoo.com",
    mobile: "609-351-8732",
    role: ["breeder"],
    preferredNotificationMethod: ["text"],
    breederInfo: {
      handlerName: null,
      assignedBirds: []
    }
  },
  {
  id: "18",  // Next sequential ID
  lastUpdatedDate: "2025-11-11T12:00:00Z",
  fullName: "William Daniele",
  loftName: "Bill & Mikes Loft",
  emailAddress: "bdan989@yahoo.com",
  mobile: "732-742-4982",
  role: ["handler","breeder"],  // or ["handler","breeder"] for both roles
  preferredNotificationMethod: ["text"],
  passcode: "PASSWORD2026",
  handlerInfo: {
    section: "CENTRAL",  // or "CENTRAL", "SOUTH"
    totalBirds: 30,
    reserved: 0,
    openSlots: 20,
    breederApplicationMethod: ["call"],  // or ["text"], ["call"]
    distanceFromRaceStation: "297.67",
    breeders: []
  }
},
{
  "id": "19",
  "lastUpdatedDate": "2025-11-12T00:00:00Z",
  "fullName": "Stanley Krawiec",
  "loftName": "S. Krawiec and Sons",
  "emailAddress": "cjcsecy@aol.com",
  "mobile": "732-575-0004",
  "role": ["handler", "breeder"],
  "preferredNotificationMethod": ["email"],
  "passcode": "",
  "hideContactInfo": false,
  "handlerInfo": {
    "section": "CENTRAL",
    "totalBirds": 12,
    "reserved": 0,
    "openSlots": null,
    "breederApplicationMethod": ["email"],
    "distanceFromRaceStation": "291.537",
    "breeders": []
  },
  "breederInfo": {
    "handlerName": null,
    "assignedBirds": [],
    "totalBirdsForRace": null
  }
},
{
  "id": "20",
  "lastUpdatedDate": "2025-11-12T00:00:00Z",
  "fullName": "RAFAL CHAIM",
  "loftName": "CHAIM FAMILY LOFT",
  "emailAddress": "IRCHAIM@YAHOO.COM",
  "mobile": "973-626-2838",
  "role": ["handler"],
  "preferredNotificationMethod": ["email"],
  "passcode": "",
  "hideContactInfo": false,
  "handlerInfo": {
    "section": "NORTH ",
    "totalBirds": 0,
    "reserved": 0,
    "openSlots": null,
    "breederApplicationMethod": ["email"],
    "distanceFromRaceStation": "293.34",
    "breeders": []
  },
  "breederInfo": {
    "handlerName": null,
    "assignedBirds": [],
    "totalBirdsForRace": null
  }
}
];
